const buildEditOptionsVariable = ({ columns }, { options }, hasVariants) => {
  if (!hasVariants) {
    const deleteAllOptions = options.length && {
      deleted: options.map(({ id }) => id)
    };
    return { ...deleteAllOptions };
  }

  const variantColumns = columns.filter(
    (column) => !["price", "stock", "sku"].includes(column.stateKey)
  );

  const deleted = getDeletedOptions(options, variantColumns);

  const edited = getEditedOptions(variantColumns, options);

  const created = getCreatedOptions(variantColumns);

  return {
    deleted: deleted.length ? deleted : null,
    edited: edited.length ? edited : null,
    created: created.length ? created : null
  };
};

const getDeletedOptions = (options, variantColumns) =>
  options
    .map(({ id }) => id)
    .filter(
      (optionId) =>
        !variantColumns.find((variantColumn) => variantColumn.id === optionId)
    );

const getEditedOptions = (variantColumns, options) => {
  const getOptionHaveBeenChanged = (variantColumn) =>
    variantColumn.id &&
    options.find(
      (option) =>
        variantColumn.id === option.id &&
        variantColumn.title.trim() !== option.name.trim()
    );

  return variantColumns
    .filter(getOptionHaveBeenChanged)
    .map(({ id, title }) => ({
      id,
      name: title
    }));
};

const getCreatedOptions = (variantColumns) =>
  variantColumns.filter(({ id }) => !id).map(({ title }) => title.trim());

export default buildEditOptionsVariable;
